import { FC, ReactNode } from 'react';
import clsx from 'clsx';

type SubCategoryProps = {
  title: string;
  children: ReactNode;
  className?: string;
  hidden?: boolean;
};

const SubCategory: FC<SubCategoryProps> = ({ title, children, className, hidden }) => {
  if (hidden) return null;

  return (
    <div className={clsx('mb-2 pb-2', className)}>
      <div className="fs-10 fw-bold text-moody-blue text-uppercase mb-1">{title}</div>
      {children}
    </div>
  );
};

export default SubCategory;
